import { cn } from '../../lib/utils';

type FieldStrengthTone = 0 | 1;

const TONE_CLASSES: Record<FieldStrengthTone, string> = {
    0: 'border-[rgba(78,165,217,0.55)] bg-[rgba(78,165,217,0.14)] text-blue',
    1: 'border-foreground/25 bg-foreground/[0.08] text-foreground',
};

const fieldStrengthTone = (fieldStrength: number): FieldStrengthTone =>
    fieldStrength <= 2 ? 0 : 1;

interface FieldStrengthProps {
    fieldStrength: number;
    className?: string;
}

export default function FieldStrengthChip({
    fieldStrength,
    className,
}: FieldStrengthProps) {
    return (
        <span
            className={cn(
                'inline-flex min-w-12 items-center justify-center rounded-full border px-2.5 py-1 text-xs font-semibold leading-none tabular-nums',
                TONE_CLASSES[fieldStrengthTone(fieldStrength)],
                className
            )}
        >
            {fieldStrength} T
        </span>
    );
}

export function FieldStrengthTile({
    fieldStrength,
    className,
}: FieldStrengthProps) {
    return (
        <span
            className={cn(
                'flex h-11 w-11 shrink-0 flex-col items-center justify-center rounded-md border leading-none tabular-nums',
                TONE_CLASSES[fieldStrengthTone(fieldStrength)],
                className
            )}
        >
            <span
                className={cn(
                    'font-semibold tracking-tight',
                    String(fieldStrength).length > 4 ? 'text-sm' : 'text-base'
                )}
            >
                {fieldStrength}
            </span>
            <span className="mt-0.5 text-[9px] font-semibold uppercase tracking-wider">
                Tesla
            </span>
        </span>
    );
}
